import './logoContainer.scss'

// image
import { images } from "../../../constants/images";

const LogoContainer = () => {
  return (
    <div className='logoContainer'>
        <div className="logo">
            <img src={images.logo} alt="Logo" />
          </div>
          <div className="appName">
            <span className='title'>HAIQU</span>
            <span>Human-AI QUestionnaire</span>
          </div>
    </div>
  )
}

export default LogoContainer